<template>
  <!-- <div class="top-nav-box" :class="[{pt80:activeNavItem!='home'}]"> -->
	<div class="top-nav-box">
    <nav class="navbar navbar-default navbar-fixed-top"
	:class="[
		swiperIndex>0 && activeNavItem=='home'?'hide-navbar':'show-navbar',
		  activeNavItem=='home'?'nav-bg-color1':'nav-bg-color2',
		  activeNavItem!='home' && scrollTop>0 ?'hide-navbar':'show-navbar'
		  ]">
		<div class="container">
    		<div class="navbar-header">
    			<button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
    				data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
    				<span class="sr-only">Toggle navigation</span>
    				<span class="icon-bar"></span>
    				<span class="icon-bar"></span>
    				<span class="icon-bar"></span>
    			</button>
    			<!-- <a class="navbar-brand logo-box" href="#">
    				<img src="@/assets/img/logo1.png" class="logo" alt="" srcset="">
    			</a> -->
    		</div>
    		<div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
				<menuItem @activeMenu="activeMenu" :list="routes"></menuItem>
    		</div>
    	</div>
    </nav>
  </div>
</template>

<script scoped>
import menuItem from './menuItem.vue';
import { mapState,mapMutations } from 'vuex';
export default {
	name: 'topNav',
	components: {
		menuItem
	},
	data() {
		return {
			activeNavItem:"home",
			swiperIndex:0,
			swiperChangeState:"end",
			scrollTop:0,
		}
	},
	watch: {
		$route(to, from) {
			if(this.activeNavItem!=to.meta.value){
				console.log(this.$route);
				this.activeNavItem = to.meta.value;
				this.swiperIndex=0;
			}
			
		},
		
		homeSwiperOption: {
			immediate: false,
			deep: true,
			handler(newValue, oldValue) {
				// console.log(newValue);
				if(newValue.activeIndex!==undefined || newValue.activeIndex!==null){
					this.swiperIndex=newValue.activeIndex;
				}
				if(newValue.swiperChangeState){
					this.swiperChangeState=newValue.swiperChangeState;
					// console.log(this.swiperChangeState,newValue.swiperChangeState);
					
				}
				if(this.activeNavItem=='home' && this.swiperIndex>0){
					this.show_hide_navbar='hide-navbar';
				}else{
					this.show_hide_navbar='show-navbar';
				}
				this.$forceUpdate();
			}
		}
	},
	computed: {
        ...mapState(['homeSwiperOption']),
		routes(){
			return this.$router.options.routes;
		}
    },
	created() {
		this.swiperIndex=0;
		// console.log(this.activeNavItem);
		
	},
	mounted () {
		window.addEventListener('scroll', this.handleWheel);
	},
	methods: {
		handleWheel(event){
			let scrollTop=window.pageYOffset || document.documentElement.scrollTop;
			// console.log("鼠标滚动事件：",pageYOffset );
			this.scrollTop=scrollTop;
			
		},
		activeMenu(e){
			// console.log("顶部导航回调：",e);
			if($(".navbar-toggle")[0] && this.$platform.platformType()=='mobile'){
				$(".navbar-toggle").click();
			}
			
		},

		...mapMutations(['setHomeSwiperOption'])
	},
}
</script>
<style scoped lang="scss">
	.logo-box{
		// margin-top: 12px;
	}
	.color1{
		color: #ffffff;
	}
	.navbar-default .navbar-nav>li>a{
		color:  #ffffff;
	}
	.navbar-default .navbar-nav>li>a:hover{
		color: #ffffff;
		
	}
	.navbar-header{
		position: relative;
		z-index: 10;
	}
	.navbar-collapse.collapse{
		position: relative;
		z-index: 9;
		background-color: transparent;
	}
	
	.navbar-default{
		// transition: all 0.5s ease-in-out;
		border:0  !important;
		&:hover{
			transition: all 0.5s ease-in-out;
			background-color: rgba(255,255,255,1);
			::v-deep .title{
				color:#333333;
				// .text-line-x{
				// 	background-color:#002880;
				// }
			}
			::v-deep .logo{
				display: none;
			}
			::v-deep .logo1{
				display: block;
			}
			::v-deep .tel-img{
				background-image: url("../assets/img/tel-icon1.png");
			}
			::v-deep .tel-box{
				color: #063390;
				border-color:rgba(6, 51, 144,0.6);
			}
		}
	}
	
	.show-navbar{
		top:0rem;
		// transition: all 0.5s ease-in-out;
		
		box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
	}
	.hide-navbar{
		// top:-9.4rem;
		opacity: 0;
		transition: all 0.5s ease-in-out;
		&:hover{
			top:0rem;
			opacity: 1;
			transition: all 1s ease-in-out;
			box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);


		}
	}
	.nav-bg-color1{
		transition: all 0.5s ease-in-out;
		background-color: rgba(0,6,27,0);
		
		
		::v-deep .title{
			color:#ffffff;
			&:hover{
				.text-line-x{
					display: flex;
					background-color: #002880;
				}
			}
		}
		::v-deep .logo{
			display: block;
		}
		::v-deep .logo1{
			display: none;
		}
		
	}
	.nav-bg-color2{
		transition: all 0.5s ease-in-out;
		background-color: rgba(255,255,255,1);
		::v-deep .title{
			color:#333333;
			&:hover{
				.text-line-x{
					display: flex;
					background-color: #002880;
				}
			}

			
		}
		::v-deep .logo{
			display: none;
		}
		::v-deep .logo1{
			display: block;
		}
		::v-deep .tel-box{
			color: #063390;
			border-color:rgba(6, 51, 144,0.6);
		}
		::v-deep .tel-img{
			background-image: url("../assets/img/tel-icon1.png");
		}
	}
	.navbar{
		margin-bottom: 0;
	}
	.navbar-brand{
		height: 18.9rem;
	}
	.logo{
		width: 18.9rem;
		height: 8rem;
		// margin-top: 10px;
	}
	.pt80{
		padding-top: 8rem;
	}
</style>
